import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { capitalizeFirstLetter } from '../../utils/capitalizeFirstLetter';
import { DataTypesAPIResponse } from '../fields/FieldsSettings/FieldsSettingsTypes';

interface DataTypeSelectProps {
  dataTypesResponse?: DataTypesAPIResponse[];
  handleDataTypeChange: (dataType: string) => void;
  haveTitle?: boolean;
  readOnly?: boolean;
  selectedDataType: string;
}

const DataTypeSelect: React.FC<DataTypeSelectProps> = ({
  dataTypesResponse,
  handleDataTypeChange,
  haveTitle = true,
  readOnly,
  selectedDataType,
}) => {
  return (
    <FormControl fullWidth>
      {haveTitle && <InputLabel id="data-type-select-label">Data Type</InputLabel>}

      <Select
        data-cy="data-type-selector"
        disabled={readOnly}
        fullWidth
        id="data-type-select"
        labelId="data-type-select-label"
        onChange={(e) => handleDataTypeChange(e.target.value as string)}
        value={selectedDataType}
      >
        {dataTypesResponse?.map((dataTypeOption, index) => (
          <MenuItem key={index} value={dataTypeOption.name} data-cy="data-type-selector-item">
            {capitalizeFirstLetter(dataTypeOption.name)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DataTypeSelect;
